module.exports = __webpack_public_path__ + "img/motorbike-fleet.1b139bfe.png";